import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { track, trackError } from './lib/analytics'

// Global error tracking (analytics-9). These report to GA4 only if/when consent
// has been granted; otherwise trackError just logs to the console.
window.addEventListener('error', (event) => {
  trackError(event.error ?? event.message, 'window.error')
})
window.addEventListener('unhandledrejection', (event) => {
  trackError(event.reason, 'unhandledrejection')
})

// Core Web Vitals reporting (analytics-5). Lazy import so it never blocks
// initial render and is dropped from the critical path.
import('web-vitals')
  .then(({ onCLS, onINP, onLCP }) => {
    const report = ({ name, value, id }: { name: string; value: number; id: string }) => {
      track('web_vitals', { name, value, id })
    }
    onCLS(report)
    onINP(report)
    onLCP(report)
  })
  .catch(() => {
    // web-vitals failing to load must never break the app.
  })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
